/* tslint:disable */
/* eslint-disable */
/**
 * Intee
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OfferCreatePlaceModel
 */
export interface OfferCreatePlaceModel {
    /**
     * 
     * @type {string}
     * @memberof OfferCreatePlaceModel
     */
    name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof OfferCreatePlaceModel
     */
    latitude?: number;
    /**
     * 
     * @type {number}
     * @memberof OfferCreatePlaceModel
     */
    longitude?: number;
}

export function OfferCreatePlaceModelFromJSON(json: any): OfferCreatePlaceModel {
    return OfferCreatePlaceModelFromJSONTyped(json, false);
}

export function OfferCreatePlaceModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): OfferCreatePlaceModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'latitude': !exists(json, 'latitude') ? undefined : json['latitude'],
        'longitude': !exists(json, 'longitude') ? undefined : json['longitude'],
    };
}

export function OfferCreatePlaceModelToJSON(value?: OfferCreatePlaceModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'latitude': value.latitude,
        'longitude': value.longitude,
    };
}

